/**
 * Calculates the cost of a subscription with a provided coupon.
 * @param  {Number} pennies - the base cost of the subscription.
 * @param  {Object} [coupon] - the coupon object
 * @param  {Object} [divisor] - optional interval to divide penies by (used for monthly calculations)
 * @return {String}
 */
function applyDiscount(pennies, coupon) {
  // Try to discount coupon.
  if (coupon) {
    if (coupon.amountOff) pennies -= coupon.amountOff;
    if (coupon.percentOff) pennies -= pennies * (coupon.percentOff / 100);
  }

  return pennies / 100;
}

export default applyDiscount;
